var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.144.33c-1.026.016-1.866.881-1.852 1.906v7.388h-7.342c-.554-.007-1.093.229-1.427.601s-.479.833-.479 1.28.145.908.479 1.28.873.608 1.427.601h9.223c1.027 0 1.881-.853 1.881-1.881v-9.269c.014-1.048-.863-1.922-1.91-1.906zm9.653-.023c-1.027.016-1.868.883-1.852 1.91v9.219c0 1.027.854 1.881 1.881 1.881h9.267c.554.008 1.093-.229 1.427-.602.335-.371.48-.832.48-1.279s-.145-.908-.479-1.281c-.334-.371-.873-.607-1.427-.6h-7.386v-7.338c.016-1.05-.861-1.927-1.911-1.91zm.03 18.306c-1.027 0-1.88.854-1.881 1.881v9.267c-.007.554.229 1.093.601 1.427s.833.479 1.28.479.908-.146 1.28-.479.608-.873.601-1.427v-7.386h7.34c.554.008 1.093-.229 1.427-.601s.479-.833.479-1.28-.146-.908-.479-1.28c-.334-.372-.873-.608-1.427-.601zm-18.921.069c-.554-.008-1.093.229-1.427.6-.334.372-.479.833-.479 1.281s.145.908.479 1.279c.334.373.873.609 1.427.602h7.386v7.341c-.007.554.229 1.093.601 1.427.372.335.833.48 1.28.48s.908-.146 1.28-.48.608-.873.601-1.427v-9.222c0-1.027-.854-1.881-1.881-1.881z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortScreen);
export default __webpack_public_path__ + "static/media/short-screen.0c8a24d289ea1f28eb8fbe5589fb9b6b.svg";
export { ForwardRef as ReactComponent };